import React from 'react'

const Contact = () => {
  return (
    <><h1>Contact Articles</h1></>
  )
}

export default Contact